import React from "react";
import VlogList from "../VlogList/VlogList";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const VlogListTechSeries = () => {
  const title = "סדרות טכנולוגיה";
  const description = `ברוכים הבאים לאזור סדרות הטכנולוגיה! כאן תמצאו סדרות ממוקדות נושא, כל אחת בנויה מפרקים קצרים וברורים. כל סדרה כוללת קישור לדף הסדרה ולוולוגים רלוונטיים. כרגע יש כאן שתי סדרות התחלתיות ואתם מוזמנים להרחיב.`;

  const vlogs = [
    {
      topic: "סדרת Zustand",
      vlogs: [
        {
          id: "TechSeries/Zustand/Vlog1",
          name: "Zustand – מבוא והשוואה מהירה לפתרונות State Management",
        },
        {
          id: "TechSeries/Zustand/Vlog2",
          name: "Zustand – התקנה, Store ראשון וקריאת State עם Selectors",
        },
        {
          id: "TechSeries/Zustand/Vlog3",
          name: "Zustand – ה-Store מבפנים, אימיוטביליות והבדל מ-Context",
        },
        {
          id: "TechSeries/Zustand/Vlog4",
          name: "Zustand – Selectors, shallow comparison ו-Best Practices",
        },
        {
          id: "TechSeries/Zustand/Vlog5",
          name: "Zustand – Middlewares ו-Persistency",
        },
        {
          id: "TechSeries/Zustand/Vlog6",
          name: "Zustand – סלקטורים מתקדמים ופיצול קומפוננטות",
        },
        {
          id: "TechSeries/Zustand/Vlog7",
          name: "Zustand – פיצול קומפוננטות והשוואה ל-Context",
        },
        {
          id: "TechSeries/Zustand/Vlog8",
          name: "Zustand + Hooks – useEffect/useMemo, Derived & Computed State",
        },

        {
          id: "TechSeries/Zustand/Vlog9",
          name: "Zustand – Performance: Selectors, Equality ו-Optimizations",
        },

        {
          id: "TechSeries/Zustand/Vlog10",
          name: "Zustand – Integration: TanStack Query, Forms, Next.js",
        },

        {
          id: "TechSeries/Zustand/Vlog11",
          name: "Zustand – Best Practice & Advanced Patterns: Immer, State Machines ו-Selectors",
        },

        {
          id: "TechSeries/Zustand/Vlog12",
          name: "Zustand – Behind the Scenes: create, source ו-future-proof",
        },
      ],
    },
    {
      topic: "סדרת SQLAlchemy",
      vlogs: [
        {
          id: "TechSeries/SQLAlchemy/Vlog1",
          name: "SQLAlchemy – מבוא, ORM מול SQL והיכן זה נכנס בארכיטקטורה",
        },
        {
          id: "TechSeries/SQLAlchemy/Vlog2",
          name: "SQLAlchemy – ה-Engine – השער לעולם ה־Database",
        },
        {
          id: "TechSeries/SQLAlchemy/Vlog3",
          name: "SQLAlchemy – Declarative Base – איך מגדירים מודלים?",
        },
        {
          id: "TechSeries/SQLAlchemy/Vlog4",
          name: "SQLAlchemy – Context manager וה־Unit of Work pattern",
        },
        {
          id: "TechSeries/SQLAlchemy/Vlog5",
          name: "SQLAlchemy – CRUD בסיסי – עבודה יומיומית עם נתונים",
        },
        {
          id: "TechSeries/SQLAlchemy/Vlog6",
          name: "SQLAlchemy – השאילתות מאחורי הקלעים – מה באמת נשלח ל־DB",
        },
        {
          id: "TechSeries/SQLAlchemy/Vlog7",
          name: "SQLAlchemy – מערכות יחסים – One-to-Many, Many-to-Many",
        },
        {
          id: "TechSeries/SQLAlchemy/Vlog8",
          name: "SQLAlchemy – Inheritance – ירושה בין מודלים",
        },
        {
          id: "TechSeries/SQLAlchemy/Vlog9",
          name: "SQLAlchemy – Alembic: מיגרציות, autogenerate ו-best practices",
        },
        {
          id: "TechSeries/SQLAlchemy/Vlog10",
          name: "SQLAlchemy – Performance: N+1 Problem, Loading Strategies ו-Optimization",
        },
        {
          id: "TechSeries/SQLAlchemy/Vlog11",
          name: "SQLAlchemy – Mixing ORM with Core: מתי ואיך לשלב גישות",
        },
        {
          id: "TechSeries/SQLAlchemy/Vlog12",
          name: "SQLAlchemy – מתקדמים: Custom Types, Events ו-Extensions",
        },
      ],
    },
    {
      topic: "סדרת React Context",
      vlogs: [
        {
          id: "TechSeries/ReactContext/Vlog1",
          name: "הבסיס של React Context",
        },
        {
          id: "TechSeries/ReactContext/Vlog2",
          name: "TypeScript + Context לעומק",
        },
        {
          id: "TechSeries/ReactContext/Vlog3",
          name: "Pattern עיצובי מתקדם",
        },
      ],
    },
    {
      topic: "סדרת useShallow",
      vlogs: [
        {
          id: "TechSeries/useShallow/Vlog1",
          name: "היכרות עם shallow ו־useShallow ב-Zustand",
        },
        {
          id: "TechSeries/useShallow/Vlog2",
          name: "חמשת הכללים של useShallow — מתי כן ומתי לא",
        },
        {
          id: "TechSeries/useShallow/Vlog3",
          name: "מבנה נכון של store ו־selectors מתקדמים",
        },
        {
          id: "TechSeries/useShallow/Vlog4",
          name: "איך לדעת אם useShallow באמת שיפר ביצועים",
        },
        {
          id: "TechSeries/useShallow/Vlog5",
          name: "איך shallow באמת עובד",
        },
      ],
    },
  ];

  return (
    <>
      <VlogList title={title} description={description} vlogs={vlogs} />
    </>
  );
};

export default VlogListTechSeries;
